import styled from "styled-components";
import { propStyling, tombac } from "../../../shared";
import { textStyles } from "../../../shared/textStyles";
import { ToggleGroupSize } from "../ToggleGroupRoot";

export const ItemContainer = styled.label<{ size: ToggleGroupSize }>`
  all: initial;

  ${({ size }) =>
    tombac.text({
      fontSize: size === "xs" ? 12 : 14,
      color: "inherit",
    })};

  cursor: default;
  display: block;
  flex: 1;
  margin: ${tombac.unit(0, 1)};
  min-width: max-content;
  overflow: hidden;

  ${propStyling};
  ${textStyles};
`;
